import type {
  Block,
  Location,
  IPlayer,
  IClub,
  ICoach,
  IManager,
  IStaff,
} from '../../api/api-clients';

// Readable enum mirroring backend ProfileType (None=0, Club=1, Manager=2, Staff=3, Player=4, Coach=5)
export enum AppProfileType {
  None = 'None',
  Club = 'Club',
  Manager = 'Manager',
  Staff = 'Staff',
  Player = 'Player',
  Coach = 'Coach',
}

export interface BaseProfile {
  userId?: string;
  id?: string;
  /** Display name: full name from PersonalData (name + lastName) or teamName for Club. */
  nombre: string;
  /** Optional display alias from PersonalData. Not applicable to Club. */
  alias?: string;
  profilePicture?: string;
  location?: Location;
  city?: string;
  country?: string;
  description?: string;
  additionalInformation?: string;
  videos?: string[];
  blocks?: Block[];
  blocked?: boolean;
  verified?: boolean;
  deleted?: boolean;
  registeredOn?: Date;
  verifiedOn?: Date;
  verifiedUntil?: Date;
  deletedOn?: Date;
  ratedCount?: number;
  rate?: number;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  introVideo?: string;
  introVideoThumbnail?: string;
  introVideoDuration?: number;
}

export interface PlayerProfile extends BaseProfile, IPlayer {
  type: AppProfileType.Player;
}

export interface ClubProfile extends BaseProfile, IClub {
  type: AppProfileType.Club;
}

export interface CoachProfile extends BaseProfile, ICoach {
  type: AppProfileType.Coach;
}

export interface ManagerProfile extends BaseProfile, IManager {
  type: AppProfileType.Manager;
}

export interface StaffProfile extends BaseProfile, IStaff {
  type: AppProfileType.Staff;
}

export type AppProfile =
  | PlayerProfile
  | ClubProfile
  | CoachProfile
  | ManagerProfile
  | StaffProfile;
